import React, { Component } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button, Form, Header } from "semantic-ui-react";

class Signatures extends Component {
  state = {};

  onSigEnd = (e, d) => {
    this.validateSigs();
  };

  onCoRenterSigClear = (e) => {
    e.preventDefault();
    this.coRenterSigCanvas.clear();

    this.validateSigs();
  };

  onRenterSigClear = (e) => {
    e.preventDefault();
    this.renterSigCanvas.clear();

    this.validateSigs();
  };

  onWitnessSigClear = (e) => {
    e.preventDefault();
    this.witnessSigCanvas.clear();

    this.validateSigs();
  };

  validateSigs = () => {
    let sigsToValidate = [
      this.renterSigCanvas.isEmpty(),
      this.witnessSigCanvas.isEmpty(),
    ];

    if (this.props.coRenter) {
      sigsToValidate.push(this.coRenterSigCanvas.isEmpty());
    }

    if (sigsToValidate.includes(true)) {
      this.props.setComplete(false);
    } else {
      let signatures = [
        { type: "renter", image: this.renterSigCanvas.toDataURL() },
        { type: "witness", image: this.witnessSigCanvas.toDataURL() },
      ];

      if (this.props.coRenter) {
        signatures.push({
          type: "co_renter",
          image: this.coRenterSigCanvas.toDataURL(),
        });
      }

      this.props.setSignatures(signatures);
    }
  };

  render() {
    return (
      <div
        style={{
          padding: "25px 0",
          marginBottom: "20px",
          borderBottom: "1px solid #eee",
        }}
      >
        <Header
          size="large"
          content="Signatures"
          subheader="Pick a signature style to sign your Contract and Recurring Payment Authorization with"
        />
        <Form>
          <Form.Select
            options={[
              { key: 1, text: "Style 1", value: "Cedarville Cursive" },
              { key: 2, text: "Style 2", value: "Dawning of a New Day" },
              { key: 3, text: "Style 3", value: "Homemade Apple" },
              { key: 4, text: "Style 4", value: "La Belle Aurore" },
              { key: 5, text: "Style 5", value: "Zeyada" },
            ]}
            value={this.props.fontFamily}
            onChange={this.props.onFontChange}
          />
          <div
            className="signature-previews"
            style={{
              display: "flex",
              marginTop: "25px",
              paddingLeft: "15px",
            }}
          >
            <h1
              style={{
                fontFamily: this.props.fontFamily,
                margin: "0 45px 0 0",
                display: "flex",
                flexDirection: "column",
                minWidth: "300px",
                fontSize: "40px",
                fontWeight: "400",
              }}
            >
              {this.props.renter}
              <span style={{ fontSize: "12px", fontFamily: "Lato" }}>
                {this.props.renter}
              </span>
            </h1>
            {this.props.coRenter && (
              <h1
                style={{
                  fontFamily: this.props.fontFamily,
                  margin: "0",
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "300px",
                  fontSize: "40px",
                  fontWeight: "400",
                }}
              >
                {this.props.coRenter}
                <span style={{ fontSize: "12px", fontFamily: "Lato" }}>
                  {this.props.coRenter}
                </span>
              </h1>
            )}
          </div>
        </Form>
        {/* <div>
          <SignatureCanvas
            canvasProps={{width: 500, height: 200}}
            ref={(ref) => { this.renterSigCanvas = ref}}
            onEnd={this.onSigEnd}
          />
          <p>{this.props.renter} - Renter</p>
          <Button
            negative
            content="Clear Signature"
            basic
            icon="eraser"
            labelPosition="right"
            onClick={this.onRenterSigClear}
          />
        </div>
        {
          this.props.coRenter &&
            <div>
              <SignatureCanvas
                canvasProps={{width: 500, height: 200}}
                ref={(ref) => { this.coRenterSigCanvas = ref }}
                onEnd={this.onSigEnd}
              />
              <p>{this.props.coRenter} - Co-Renter</p>
              <Button
                negative
                content="Clear Signature"
                basic
                icon="eraser"
                labelPosition="right"
                onClick={this.onCoRenterSigClear}
              />
            </div>
        }
        <div>
          <SignatureCanvas
            canvasProps={{width: 500, height: 200}}
            ref={(ref) => { this.witnessSigCanvas = ref}}
            onEnd={this.onSigEnd}
          />
          <p>Witness</p>
          <Button
            negative
            basic
            content="Clear Signature"
            icon="eraser"
            labelPosition="right"
            onClick={this.onWitnessSigClear}
          />
        </div> */}
      </div>
    );
  }
}

export default Signatures;
